export default "__VITE_ASSET__DQ$H9VYD__"